<template>
  <div class="outline">
    <div v-show="show" class="highlight">
      <span class="triangle"></span>
      <svg-icon icon="correct"/>
    </div>
    <div v-show="!show" class="not-highlight"></div>
  </div>
</template>

<script>
export default {
  props: {
    show: {
      type: Boolean,
      default: false,
    },
  },
}
</script>

<style lang="scss" scoped>
.outline {
  .highlight {
    position: absolute;
    display: inline-block;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    border: 2px solid $theme-green;
    box-sizing: border-box;
    .triangle {
      position: absolute;
      top: 0;
      right: 0;
      width: 0;
      height: 0;
      border-style: solid;
      border-width: 0 36px 36px 0;
      border-color: transparent $theme-green transparent transparent;
    }
    .svg-icon {
      position: absolute;
      top: 5px;
      right: 5px;
      color: #fff;
    }
  }

  .not-highlight {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    border: 1px solid $theme-textplaceholder;
  }
}
</style>